module.exports = __webpack_public_path__ + "public/images/about-8.f4ee563f1a847a143550a40bbe125e1e.png";